__turbopack_context__.v({
  "checkbox": "CollapsibleContent-module__n80l3a__checkbox",
  "code": "CollapsibleContent-module__n80l3a__code",
  "codeBlock": "CollapsibleContent-module__n80l3a__codeBlock",
  "collapseLabel": "CollapsibleContent-module__n80l3a__collapseLabel",
  "container": "CollapsibleContent-module__n80l3a__container",
  "expandLabel": "CollapsibleContent-module__n80l3a__expandLabel",
  "fileRefs": "CollapsibleContent-module__n80l3a__fileRefs",
  "frame": "CollapsibleContent-module__n80l3a__frame",
  "toggle": "CollapsibleContent-module__n80l3a__toggle",
});
